import { AxiosResponse } from 'axios'
import { http } from '../../../utils'
import { BulkInvoicePreviewResponse } from './types'

function buildBulkInvoicesRequestBody(
  startDate: string,
  endDate: string,
  createDate: string,
  billFormat: string,
  siteIds?: number[]
) {
  const requestBody: Record<string, unknown> = {
    startDate,
    endDate,
    createDate,
    billFormat,
  }

  if (siteIds && siteIds.length > 0) {
    requestBody.siteIds = siteIds
  }

  return requestBody
}

export function previewBulkInvoices(
  startDate: string,
  endDate: string,
  createDate: string,
  billFormat: string,
  siteIds?: number[]
) {
  return http
    .post<BulkInvoicePreviewResponse>(
      '/interim_bill/pvt/bulk_preview',
      buildBulkInvoicesRequestBody(
        startDate,
        endDate,
        createDate,
        billFormat,
        siteIds
      )
    )
    .then((response: AxiosResponse<BulkInvoicePreviewResponse>) => response.data)
}
